const clearAuth = () => {
	localStorage.removeItem("auth");
}

const clearAuthentic = () => {
	localStorage.removeItem("authentic");
}

const clearToken = () => {
	localStorage.removeItem('token')
}

const clearClinicId = () => {
	localStorage.removeItem('clinic_id')
}

const clearRememberPassword = () => {
	localStorage.removeItem("rememberPassword");
}

export {
	clearAuthentic,
	clearAuth,
	clearToken,
	clearClinicId,
	clearRememberPassword,
}
